import { render, staticRenderFns } from "./part-replacement-detail.vue?vue&type=template&id=aed8db9e&"
import script from "./part-replacement-detail.vue?vue&type=script&lang=js&"
export * from "./part-replacement-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports